import React, { Fragment } from 'react'
import { AsyncTypeahead, Highlighter, Menu, MenuItem } from 'react-bootstrap-typeahead'
import { append } from 'ramda'
import './style.scss'
import clientImage from 'components/SearchComponent/client-avatar.svg'
import newUser from './new-user.svg'
import { FetchRequest } from '@rails/request.js'

const Filter = ({ filter, text, option }) => {
  if (!filter) return null
  if (!option[filter]) return null

  return (
    <div key={filter}>
      <small className='text-grey'>
        <Highlighter search={text}>{option[filter]}</Highlighter>
      </small>
    </div>
  )
}

const Error = ({ error }) => {
  return <p className='inline-errors my-2'>{error}</p>
}

export default class PersonTypeaheadInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      ...props
    }

    this._renderMenu = this._renderMenu.bind(this)
    this._handleSearch = this._handleSearch.bind(this)
  }

  _handleSearch(text) {
    this.setState({ isLoading: true })

    var urlParams = new URLSearchParams()
    urlParams.append('q', text)
    if (this.state.is_client) {
      urlParams.append('is_client', this.state.is_client)
    }
    if (this.state.is_volunteer) {
      urlParams.append('is_volunteer', this.state.is_volunteer)
    }
    const url = this.state.endpointUrl + '?' + urlParams
    const request = new FetchRequest('GET', url, { responseKind: 'json' })
    request.perform()
      .then(async response => {
        if (response.ok) {
          const data = await response.json
          this.setState({
            isLoading: false,
            options: data
          })
        }
      })
  }

  _renderMenu(results, menuProps, state) {
    const { filterBy } = this.state
    const items = results.map((result, index) => (
      <Fragment key={result.value}>
        <MenuItem key={index} option={result} position={index}>
          <div className='d-flex'>
            <img src={result.photo ? result.photo : clientImage} className='client-icon rounded-circle my-auto' />
            <span className='me-3 my-auto' data-person-id={result.value} data-person-name={result.name}>
              <Highlighter search={state.text}>{result.label}</Highlighter>
              {filterBy &&
                filterBy.map((filter, idx) => <Filter key={idx} filter={filter} text={state.text} option={result} />)}
            </span>
            <div className='my-auto ms-auto'>
              <span className='text-grey fw-bold'>{result.roles}</span>
            </div>
          </div>
        </MenuItem>
      </Fragment>
    ))

    if (!results.length) {
      return null
    } else {
      return (
        <Menu {...menuProps}>
          {!this.state.is_client && (
            <div className='info-text'>
              Are they already in the system? (Just keep typing or select “This is a new user” option to dismiss)
            </div>
          )}
          {items}
          {!this.state.is_client && (
            <div
              onClick={event => event.target.closest('.rbt-menu').classList.add('d-none')}
              className='d-flex new-user'
            >
              <img src={newUser} className='client-icon rounded-circle my-auto' />
              <span className='my-auto'>This is a new user</span>
            </div>
          )}
        </Menu>
      )
    }
  }

  render() {
    const { options, disabled, selected, id, filterBy, errors, placeholder, className } = this.state

    const handleOnChange = item => {
      let value = null
      if (item[0]) {
        value = item[0].value
      }

      this.setState({ selected: value, errors: null })

      const selectedPerson = options.find(item => item.value === value)

      if (this.props.onChange) {
        this.props.onChange(selectedPerson)
      }
    }

    return (
      <Fragment>
        <AsyncTypeahead
          placeholder={placeholder}
          id={id || 'visit-recipient'}
          renderMenu={this._renderMenu}
          filterBy={append('label', filterBy)}
          clearButton={!disabled}
          onChange={item => handleOnChange(item)}
          onInputChange={text => {
            if (this.props.onInputChange) {
              this.props.onInputChange(text)
            }
          }}
          defaultInputValue={selected}
          className={className}
          minLength={4}
          inputProps={{ autoComplete: 'typeahead-input' }}
          isLoading={this.state.isLoading}
          onSearch={this._handleSearch}
          options={this.state.options}
        />
        {errors && <Error error={errors} />}
      </Fragment>
    )
  }
}
